import { useEffect, useRef, useState } from 'react';

export interface StickyHeaderState {
  showStickyDownloadButton: boolean;
  headerHeight: number;
  downloadSectionRef: React.RefObject<HTMLDivElement | null>;
}

export const useStickyHeader = (): StickyHeaderState => {
  const [showStickyDownloadButton, setShowStickyDownloadButton] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(64); // Default fallback
  const downloadSectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      // Try to find the header element and get its height
      const header =
        document.querySelector('header') ||
        document.querySelector('[role="banner"]') ||
        document.querySelector('.MuiAppBar-root');

      if (header) {
        const headerRect = header.getBoundingClientRect();
        setHeaderHeight(headerRect.height);
      }

      if (downloadSectionRef.current) {
        const rect = downloadSectionRef.current.getBoundingClientRect();
        // Show sticky button when original download section is scrolled out of view
        setShowStickyDownloadButton(rect.bottom < 0);
      }
    };

    // Initial call to set header height
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll); // Also update on resize

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return {
    showStickyDownloadButton,
    headerHeight,
    downloadSectionRef,
  };
};
